import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';

@Component({
    selector: 'app-my-acc-overview-ad-banner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './my-acc-overview-ad-banner.component.html',
    styleUrls: ['./my-acc-overview-ad-banner.component.scss'],
    standalone: false
})
export class MyAccOverviewAdBannerComponent implements OnInit, OnDestroy {
  cmsResponse: any;
  baseUrl: any;
  type: string;
  imageUrl: any;
  redirectionLink: any;
  cmsSub: Subscription;
  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly _dataService: DataLayerService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.cmsSub = this.cmsData
      .getComponentData('ProfileBannerComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
        if (this.cmsResponse?.external === 'true') {
          this.type = 'external';
        } else {
          this.type = 'internal';
        }
        this.imageUrl = this.cmsResponse?.media?.url
          ? this.validateDomainNameExistence(this.cmsResponse?.media?.url)
            ? this.cmsResponse.media.url
            : this.baseUrl + this.cmsResponse.media.url
          : '';
        if (this.cmsResponse?.media?.url) {
          this._dataService.addtoDataLayer('view_promotion', this.cmsResponse);
        }
        this.redirectionLink = this.cmsResponse?.urlLink
          ? this.validateDomainNameExistence(this.cmsResponse?.urlLink)
            ? this.cmsResponse?.urlLink
            : this.baseUrl + this.cmsResponse?.urlLink
          : '';
      });
  }
  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
  }
  validateDomainNameExistence(url: string) {
    return url.indexOf('https://') === 0 || url.indexOf('www.') === 0;
  }
  gtmSelectPromotion() {
    if (this.cmsResponse?.urlLink) {
      this._dataService.addtoDataLayer('select_promotion', this.cmsResponse);
    }
  }
}
